module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_33.577d4c86.png";